// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3syQu","colBig":"styles_colBig__2Ay43","colSmall":"styles_colSmall__sBXqI","shopifyNameWrapper":"styles_shopifyNameWrapper__2HxNP"};